<template>
  <div
    class="submit-panel"
    v-if="coordsApproved"
    v-on:click.self="$emit('changePointStatus'), clearInputs()"
  >
    <div class="submit-card">
      <div class="close-card-wrapper">
        <div
          class="close-card"
          v-on:click="$emit('changePointStatus'), clearInputs()"
        ></div>
      </div>
      <div class="form-container">
        <div class="form-field">
          <label for="name">Назва будівлі</label>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Введіть назву будівлі"
            v-model="userBuildingName"
          />
        </div>
        <div class="form-field">
          <label for="address">Адреса будівлі</label>
          <input
            type="text"
            name="address"
            id="address"
            placeholder="Вкажіть адресу будівлі"
            v-model="userBuildingAddress"
          />
        </div>
        <div class="form-field">
          <label for="descr">Опис будівлі</label>
          <input
            type="text"
            name="descr"
            id="descr"
            placeholder="Вкажіть стан засобів доступності"
            v-model="userDescr"
          />
        </div>
        <div class="form-field selector">
          <label for="building-type">Тип будівлі</label>
          <input
            type="text"
            class="selector"
            v-model="userBuildingType"
            readonly="readonly"
            @click="dropdownControl = !dropdownControl"
          >
          <svg
            class="jss153 jss283"
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
            @click="dropdownControl = !dropdownControl"
          >
            <path d="M7 10l5 5 5-5z"></path>
          </svg>
          <div
            class="dropdown-options"
            v-if="dropdownControl"
          >
            <div
              class="option-box"
              v-for="opt in buildingOptions"
              :key="opt"
              @click="optionSelector"
            >
              {{ opt }}
            </div>
          </div>
          <!-- <select
            name="building-type"
            id="building-type"
            v-model="userBuildingType"
          >
            <option
              v-for="opt of buildingOptions"
              :key="opt"
              :value="opt"
            > {{ opt }}</option>
          </select> -->
        </div>
        <div class="form-field checkbox">
          <label
            for="facilities"
            class="facilities"
          >Наявні засоби доступності</label>
          <div class="facilities-buttons">
            <div
              v-for="item of checkboxStatus"
              :key="item.name"
              :class="'checkbox ' +  item.name + (item.status ? ' active': '')"
              @click="checkboxUpdate(item)"
            >
              <div class="search-mark"></div>
              <p class="f-title">{{item.title}}</p>
            </div>
          </div>
        </div>
        <div class="form-field">
          <label
            for="lat"
            class="lat"
          >Координати точки</label>
          <input
            type="text"
            name="latlng"
            id="lat"
            readonly="readonly"
            :value="coordsApproved.lat"
          />
          <label
            for="lng"
            class="lng"
          ></label>
          <input
            type="text"
            name="latlng"
            id="lng"
            readonly="readonly"
            :value="coordsApproved.lng"
          />
        </div>

        <div class="submit-button">
          <!-- <input type="submit" value="Додати точку" /> -->
          <button
            type="button"
            v-on:click="submitPoint"
          >Надіслати</button>
        </div>
        <div class="message-success">
          <p v-show="userFilled">
            Дані відправлено. Після перевірки, точка з'явиться на мапі. Дякуємо
            за те, що допомагаєте місту статим кращим!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ["coordsApproved"],
  inject: ["buildingOptions"],
  data() {
    return {
      userBuildingName: "",
      userBuildingAddress: "",
      userDescr: "",
      userBuildingType: "Адмінбудівлі",
      userFilled: false,
      dropdownControl: false,
      checkboxStatus: [
        { name: "pandus", title: "Пандус", status: false },
        { name: "toilet", title: "Туалет", status: false },
        { name: "parking", title: "Парковка", status: false },
        { name: "other", title: "Інше", status: true },
      ],
    };
  },
  methods: {
    optionSelector(event) {
      this.userBuildingType = event.target.innerHTML.trim();
      this.dropdownControl = !this.dropdownControl;
    },
    checkboxUpdate(facility) {
      facility.status = !facility.status;
    },
    submitPoint() {
      if (this.userBuildingName && this.userDescr) {
        this.userFilled = true;

        this.sendToSheet();
      }
    },
    clearInputs() {
      this.userFilledObject = undefined;
      this.userBuildingName = undefined;
    },
    sendToSheet() {
      // setTimeout(() => console.log(this.coordsClicked), 200);

      let url =
        "https://script.google.com/macros/s/AKfycbwWnpJuTwGHL_elBpQCQSbxsrwS0jmV9Y0g9lOr1vHkNFYBpQMOMML4HtMZ0quKGyMgbw/exec";
      fetch(url, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        redirect: "follow",
        body: JSON.stringify({
          building_name: this.userBuildingName,
          building_address: this.userBuildingAddress,
          description: this.userDescr,
          building_type: this.userBuildingType,
          Latitude: this.coordsApproved.lat,
          Longitude: this.coordsApproved.lng,
          pandus: this.checkboxStatus[0].status,
          toilet: this.checkboxStatus[1].status,
          parking: this.checkboxStatus[2].status,
          other: this.checkboxStatus[3].status,
          checked: false,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
  },
};
</script>


<style lang="scss">
.submit-panel {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: black;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1100;
  .submit-card {
    position: relative;
    background-color: white;
    top: 10%;
    left: 20%;
    width: 824px;
    .close-card-wrapper {
      position: relative;
      .close-card {
        position: absolute;
        top: 0;
        right: 0;
        height: 32px;
        width: 32px;
        padding: 3px;
        cursor: pointer;
        &:before,
        &:after {
          content: "";
          position: absolute;
          top: 8px;
          right: 16px;
          color: white;
          height: 14px;
          // border: solid 1px rgb(160, 160, 255);
          border: solid 1px black;
          transform: rotate(45deg);
        }
        &:after {
          transform: rotate(135deg);
        }
      }
    }
    .form-container {
      // display: flex;
      display: grid;
      grid-template-columns: repeat(2, auto);
      grid-template-rows: repeat(3, auto);
      padding: 64px 64px 32px 64px;
      .form-field {
        // margin-bottom: 32px;
        margin: 0 48px 32px 0;
        width: 328px;
        position: relative;
        label {
          display: block;
          margin-bottom: 8px;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.54);
          &.lng {
            display: none;
          }
        }

        input {
          font-size: 16px;
          border: none;
          border-bottom: 2px solid black;
          display: block;
          padding: 6px 0 7px;
          width: 100%;
          position: relative;
          &.selector {
            cursor: pointer;
          }
          &#lat,
          &#lng {
            cursor: auto;
            color: grey;
          }
          &#lat {
            margin-bottom: 8px;
          }
        }
        svg {
          bottom: 4px;
          right: 0;
          position: absolute;
          height: 24px;
          width: 24px;
          cursor: pointer;
        }
        textarea:focus,
        input:focus {
          outline: none;
        }

        .dropdown-options {
          position: absolute;
          z-index: 1;
          background-color: white;
          padding: 8px 8px;
          // top: 0;
          box-shadow: 0px 3px 5px rgb(0 0 0 / 20%);
          width: 206px;
          // height: 432px;
          overflow-y: scroll;
          box-sizing: border-box;
          .option-box {
            cursor: pointer;
            padding: 4px 25px 4px 12px;
            margin-bottom: 12px;
            font-size: 14px;
            box-sizing: border-box;
            &:hover {
              background-color: #e8eef3;
            }
          }
        }
        .facilities-buttons {
          display: grid;
          grid-template-columns: repeat(2, auto);
          gap: 8px;
          // display: flex;
          // flex-wrap: wrap;
          .checkbox {
            // margin-bottom: 8px;
            // margin: 0 8px 8px 0;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            .search-mark {
              margin-right: 8px;
              position: relative;
              box-sizing: border-box;
              &:before {
                content: "";
                background: 0 0;
                border: 2px solid #000;
                height: 12px;
                width: 12px;
                transition: background 0.4s;
                display: block;
              }
              &:after {
                content: "";
                background: url(../assets/images/check-black2.svg) center
                  no-repeat;
                position: absolute;
                display: block;
                transition: opacity 0.3s;
                height: 16px;
                width: 16px;
                top: 0;
                left: 1%;
                opacity: 0;
              }
            }
            &.active {
              .search-mark:after {
                opacity: 1;
              }
            }
          }
        }
        // select {
        //   width: 176px;
        //   padding: 8px 0;
        //   -webkit-appearance: none;
        //   border: none;
        //   -moz-appearance: none;
        //   appearance: none;
        //   -ms-appearance: none;
        // }
      }

      .submit-button {
        margin-bottom: 32px;
        button {
          text-align: center;
          box-sizing: border-box;
          background-color: black;
          color: white;
          border-radius: 40px;
          min-width: 112px;
          font-size: 16px;
          min-height: 40px;
          padding: 16px 68px;
          outline: none;
          cursor: pointer;
          border: 0;
        }
      }
      .message-success {
        grid-column: 2;
        height: 48px;
        font-size: 12px;
      }
    }
  }
}
</style>